module.exports = __webpack_public_path__ + "media/images/dpd-white-922388f0.png";